/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Partner_Org_Bill_Picker_CurrentInputs */



/**
* | output |
* | --- |
* | "Current month · {range}" |
*
* @param {Partner_Org_Bill_Picker_CurrentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_bill_picker_current = /** @type {((inputs: Partner_Org_Bill_Picker_CurrentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Bill_Picker_CurrentInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktueller Monat · ${i?.range}`)
	return /** @type {LocalizedString} */ (`Current month · ${i?.range}`)
});